var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"childapp_divgrid"},[_c('header',[_c('Header')],1),_c('nav',[_c('Sidebar')],1),_c('main',{staticClass:"scroll_css1"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }